import React from "react";
import { Modal, Badge } from "react-bootstrap";
import EmailLog from "../../../types/emailLog";
import { getPageName, getUiInterface } from "../../../locales/translationUtils";

interface ViewBodyModalProps {
  email: EmailLog | null;
  onClose: () => void;
}

/**
 * Mostra o e-mail exatamente como foi enviado.
 *
 * O corpo vem num iframe com srcDoc: é o próprio conteúdo gerado pelos templates do
 * sistema (Scriban), não entrada de usuário, mas o iframe ainda assim isola o HTML da
 * página em vez de injetá-lo direto no DOM - a mesma cautela de sempre, sem custo aqui.
 */
const ViewBodyModal: React.FC<ViewBodyModalProps> = ({ email, onClose }) => {
  return (
    <Modal show={!!email} onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{getPageName("emailLog")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {email && (
          <>
            <div className="mb-2">
              <strong>{getUiInterface("to")}:</strong> {email.destinatarios}
            </div>
            {email.cco && (
              <div className="mb-2">
                <strong>{getUiInterface("bcc")}:</strong> {email.cco}
              </div>
            )}
            <div className="mb-2">
              <strong>{getUiInterface("subject")}:</strong> {email.assunto}
            </div>
            <div className="mb-3">
              <strong>{getUiInterface("status")}:</strong>{" "}
              <Badge bg={email.sucesso ? "success" : "danger"}>
                {email.sucesso ? getUiInterface("success") : getUiInterface("failure")}
              </Badge>
              {!email.sucesso && email.mensagemErro && (
                <span className="text-danger ms-2">{email.mensagemErro}</span>
              )}
            </div>
            <iframe
              title="email-body"
              srcDoc={email.corpo}
              style={{ width: "100%", height: "50vh", border: "1px solid #d6dae4", borderRadius: 6 }}
            />
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewBodyModal;
